<div class="container-fluid">
  <router-outlet></router-outlet>
  <ngx-spinner type="ball-spin-clockwise-fade" color="white" >
  </ngx-spinner>
</div>
